import { createSelector } from 'reselect';
import { get, flatten, flow, map } from 'lodash/fp';

const secondaryLinksSelector = createSelector(
  get('settings.secondaryLinks'),
  flow(
    map('items'),
    flatten
  )
);

export default secondaryLinksSelector;
